export default function handleTrackingSublevel(id) {
  let cta;

  switch (id) {
  case 5:
      cta = 'dropdown_football_boots';
      break;
  case 13:
      cta = 'dropdown_football_shirts';
      break;
  case 48:
      cta = 'dropdown_equipment';
      break;
  case 551:
      cta = 'dropdown_sale';
      break;
  default:
      cta = '';
  }

  return cta;
}
